import React, { useState, useEffect, useRef } from "react";
import styles from "../styles/SortOrder.module.css";
import { axiosReq } from "../api/axiosDefaults";
import Spinner from "react-bootstrap/Spinner";
import { t } from "i18next";
import { useHistory } from "react-router-dom";
import { useRouteFlags } from "contexts/RouteProvider";

const CustomDropdown = ({ options, onSelect, selected }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const handleSelect = (value) => {
    onSelect(value);
    setIsOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div
      ref={dropdownRef}
      className={`${styles.CustomDropdown} position-relative`}>

      <div
        className={`${styles.DropdownToggle}`}
        onClick={() => setIsOpen(!isOpen)}
      >
        {selected || <i className="fa-solid fa-arrow-down-short-wide"></i>}
      </div>

      {isOpen && (
        <ul className={`${styles.DropdownMenu} position-absolute bg-white shadow`}>
          {options.map((option, index) => (
            <li
              key={index}
              className={`${styles.DropdownItem} p-2`}
              onClick={() => handleSelect(option.value)}
              onMouseEnter={(e) => (e.target.style.backgroundColor = "#847c3d")}
              onMouseLeave={(e) => (e.target.style.backgroundColor = "transparent")}
              style={{ cursor: "pointer" }}
            >
              {option.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

const SortOrder = ({ listings, setListings }) => {
  const [sortOrder, setSortOrder] = useState("");
  const [loaded, setLoaded] = useState(false);
  const history = useHistory();
  const path = history?.location?.search;
  const { shortTermListing } = useRouteFlags();

  const handleSortChange = async (value) => {
    setSortOrder(value);
    setLoaded(true);

    const currentPath = path || "?";
    const queryParams = new URLSearchParams(currentPath.split("?")[1]);

    queryParams.set("ordering", value);
    const updatedPath = `${currentPath.split("?")[0]}?${queryParams.toString()}`;

    if (shortTermListing) {
      try {
        const { data } = await axiosReq.get(`/short-term-listings/${updatedPath}`);
        data.results = data.results.filter((listing) => listing.approved === true);
        history.push(`/short-term-listings/${updatedPath}`, { data: data });
      }
      catch (error) {
        console.error(error);
      } finally {
        setLoaded(false);
      }
    } else if (path && shortTermListing) {
      try {
        const { data } = await axiosReq.get(`/short-term-listings/${updatedPath}`);
        data.results = data.results.filter((listing) => listing.approved === true);
        history.push(`/short-term-listings/${updatedPath}`, { data: data });
      } catch (error) {
        console.error(error);
      } finally {
        setLoaded(false);
      }
    } else if (path && !shortTermListing) {
      try {
        const { data } = await axiosReq.get(`/listings/${updatedPath}`);
        data.results = data.results.filter((listing) => listing.approved === true);
        history.push(`/listings/${updatedPath}`, { data: data });
      } catch (error) {
        console.error(error);
      } finally {
        setLoaded(false);
      }
    }
    else {
      try {
        const { data } = await axiosReq.get(`/listings/?ordering=${value}`);
        data.results = data.results.filter((listing) => listing.approved === true);
        setListings(data);
      } catch (error) {
        console.error(error);
      } finally {
        setLoaded(false);
      }
    }
  };

  const sortOptions = [
    { label: t("sortOrder.mostRecent"), value: "-created_on" },
    { label: t("sortOrder.asc"), value: "price" },
    { label: t("sortOrder.desc"), value: "-price" },
  ];

  return (
    <div className="d-flex justify-content-center align-items-center mb-2">
      {loaded && <Spinner className="me-2" animation="border" />}
      <CustomDropdown
        options={sortOptions}
        onSelect={handleSortChange}
        selected={sortOptions.find((opt) => opt.value === sortOrder)?.label}
      />
    </div>
  );
};

export default SortOrder;
